import { ArticleOutlined } from '@mui/icons-material';
import { Box, Tab, Tabs } from '@mui/material';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import SearchInput from '../../components/mini/SearchInput';
import Pagination from '../../components/mini/Pagination';
import { Avatar } from "@mui/material";
import { Link, useParams } from 'react-router-dom';
import { getTransactions } from '../../controllers/transactions/getTransactions';
import { getCurrencySymbol } from '../../features/utils/currency';
import StatsOverview from '../../components/StatsOverview';
import { templateCredit } from '../../data/credit/creditData';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../redux/reducers/titleSlice';


const rows = [
  // {
  //   id: 1, customer: '',bookingDate: null,status: ''
  // }
  {
    id: 1, customer: 'Yona',date: '24th Oct, 2023 8:29AM',
    product: "Flight",
    paymentMethod: 'Card Payment',
    amount: 12412, status: 'Pending'
  }
];
[...Array(10-rows.length)].map((o,i) => rows.push({...rows[0],id:i+3}))

const filterItems = [
  {items:[{id: 0,field: 'status',operator: '',value:''}]},
  {items:[{id: 1,field: 'status', operatorValue: 'is', value: 'paid'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'pending'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'cancelled'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'refund'}]},
];


const columns = [
  {field: 'customer',headerName: 'Customer',flex:1,minWidth: 200,
    renderCell: (params) => {
      if(!params.value) return null;
      return (
        <div className='flex gap-4 items-center'>
          <Avatar>{params.value[0]}</Avatar>
          {params.value}
        </div>
      )
    }
  },
  {field: 'creditDate',headerName: 'Last Credit Date',minWidth: 150,
    renderCell: (params) => {
      if(!params.value)
        return null;

      return (
        <div className='flex flex-col'>
          {(new Date(params.value)).toDateString()}
          <small>{(new Date(params.value)).toLocaleTimeString()}</small>
        </div>
      )
    }
  },
  {field: 'creditedBy',headerName: 'Credited By',minWidth: 170,
    renderCell: (params) => {
      if(!params.value) return null;
      return (
        <div className='flex flex-col '>
          {params.value}
        </div>
      )
    }
  },
  {field: 'balance', headerName: 'Balance',
    renderCell: (params) => {
      if(!params.value) return null;
      
      return (
        <div className='flex flex-col gap-0'>
          <b className='!font-normal'>{getCurrencySymbol('NGN')}{params.value}</b>
        </div>
      )
    },
  },
  {field: 'status',headerName: 'Status',flex: 1,minWidth: 130,
    renderCell: (params) => {
      if(!params.value)
      return null;

      return (
        <div className='flex justify-between w-full relative'>
          <p className="flex-1 overflow-hidden overflow-ellipsis" title={params.value}>
            {params.value}
          </p>
        </div>
      )
    }
  },
];


export default function Index() {
  const [data,setData] = useState([]);
  const {type} = useParams();
  const [loading,setLoading] = useState(false);
  const [filter,setFilter] = useState(filterItems[0]);
  const [paginationModel,setPaginationModel] = useState({pageSize: 25,page: 0})
  // const [rowId,setRowId] = useState(null);
  const apiRef = useGridApiRef();
  var [fetchedData,setFetchedData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Credit Log'))
    console.log(type);
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  async function load() {
    setLoading(true);
    const res = await getTransactions();
    setLoading(false);
    if(res.return) {
      let data = res.data.map((row) => templateCredit(row))
      setFetchedData(data);
      setData(data);
    }
  }

  function handleSearch(val) {
    setData(fetchedData);

    val = val.toLowerCase();
    setData(data => data.filter(obj => (
      obj.customer.toLowerCase().includes(val) ||
      (new Date(obj.date)).toDateString().toLowerCase().includes(val) ||
      (parseInt(obj.amount) <= val) ||
      obj.status.includes(val)
    )))
  }
  
  return (
    <div className='w-full p-4 bg-[#f3f3f3]'>
    <div className='w-full p-4 bg-secondary'>
      {/* <div className='pb-4'>
        <StatsOverview />
      </div> */}
      <div className='flex gap-2 justify-end'>
        <Link to="/credit" className='btn2 whitespace-nowrap'><ArticleOutlined /> Credit Limit</Link>
        <button className='btn2 whitespace-nowrap'><ArticleOutlined /> Generate Report</button>
        {/* <button className='btn1 rounded-md whitespace-nowrap'><ArticleOutlined /> Activity Log</button> */}
      </div>
      <div className='flex gap-4 justify-between items-center my-3'>
        <Tabs value={filter.items[0].id} onChange={(ev,newVal) => setFilter(filterItems[newVal])} 
         variant='scrollable'
         scrollButtons={false}
         className='shadow-md'>
          <Tab label="All (216)" />
          <Tab label="Paid" />
          <Tab label="Pending" />
          <Tab label="Cancelled" />
          <Tab label="Refund" />
        </Tabs>
        <SearchInput className='text-theme1' onChange={handleSearch} />
        {/* <button className='btn2 whitespace-nowrap'><ArticleOutlined /> Generate Report</button> */}
      </div>
      <Box className=''>
        <DataGrid rows={data} columns={columns} loading={loading} autoHeight hideFooter={false}
          // getRowId={(row) => row.id}
          apiRef={apiRef}
          initialState={{
            sorting: {
              sortModel: [{field: "bookingDate",sort: 'desc'}]
            },
          }}
          filterModel={filter}
          onFilterModelChange={(newFilter) => setFilter(newFilter)}
          
          // slots={{pagination: Pagination}}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}

          // onCellEditStart={params => setRowId(params.id)}
          // hideFooterPagination
          checkboxSelection
        />
        <Pagination perPage={10} total={46} apiRef={apiRef} />
      </Box>
      </div>
    </div>
  )
}
